export default "__VITE_PUBLIC_ASSET__3121acb8__"